import { useCallback, useState } from "react";
import DriverModelTableComponent from "./driver-model-table.component";
import TableSort from "../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../shared/helpers/upper-case";
import { useQuery } from "@tanstack/react-query";
import { getDriverModels } from "../../../../../core/api/services/driverModel.service";

const DriverModelComponent = () => {
  const [PageNumber, setPageNum] = useState<number>(1);
  const [driverSearchValue, setDriverSearchValue] = useState("");
  const pageSize = 10;

  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("driverModelCode"));
  const [SortDirection, setSortDirection] = useState<any>("desc");

  const [columns, setColumns] = useState([
    {
      title: "Driver Model",
      label: "driverModelCode",
      isSorted: true,
      // width: "8rem"
    },
    {
      title: "Supplier",
      label: "SLSSupplier",
      // width: "8rem"
    },
    {
      title: "Rated Watt",
      label: "ratedWatt",
      // width: "8rem"
    },
    {
      title: "Expected Lifetime",
      label: "expectedLifeTime",
      // width: "10rem"
    },
  ]);

  const {
    data: driverModels,
    isLoading: isLoadingDriverModels,
    refetch,
  } = useQuery({
    queryKey: [
      "getDriverModels",
      PageNumber,
      SortBy,
      SortDirection,
      driverSearchValue,
    ],
    queryFn: ({ signal }) =>
      getDriverModels(
        PageNumber,
        pageSize,
        SortBy,
        SortDirection,
        driverSearchValue,
        signal
      ),
  });

  const onRefetchData = () => {
    if (driverModels?.numberOfRecords <= pageSize + 1) {
      setPageNum(1);
    }
    refetch();
  };

  const handleChangePage = useCallback((page: number): void => {
    setPageNum(page);
  }, []);

  const handleSearch = useCallback((searchVal: string): void => {
    setPageNum(1);
    setDriverSearchValue(searchVal);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  return (
    <div>
      <DriverModelTableComponent
        columns={columns}
        data={driverModels?.data}
        totalNumberOfRecords={driverModels?.numberOfRecords}
        pageSize={pageSize}
        current={PageNumber}
        onChangePage={handleChangePage}
        onRefetchData={onRefetchData}
        onChangeSort={handleChangeSort}
        isLoading={isLoadingDriverModels}
        onSearch={handleSearch}
        driverSearchValue={driverSearchValue}
      />
    </div>
  );
};

export default DriverModelComponent;
